export const ActivitiesTab = () => {
  return <div>Activities placeholder</div>;
};
